import React from 'react'
import classNames from 'classnames'

import { Drag, Drop, DragAndDrop } from '@/components/dragDrop'
import { reorder } from '@/utils/helpers'

import { PlaybookInlineEntry } from '../../components/PlaybookInlineEntry'
import { CategorySidebarRow } from '../../components/CategorySidebarRow'

export const CategoriesSidebarDisplay = ({
  categories,
  readOnly,
  onReorder,
  createAction,
  uncategorizedId,
}) => {
  const displayOrder = uncategorizedId
    ? categories.order.filter((categoryId) => categoryId !== uncategorizedId)
    : categories.order

  const handleReorder = (result) => {
    const { type, source, destination } = result

    if (!destination) {
      return
    }

    if (type === 'droppable-sidebar-category') {
      const newOrder = reorder(displayOrder, source.index, destination.index)
      onReorder(newOrder)
    }
  }

  return (
    <div className="playbook-categories-sidebar">
      <h2>Categories</h2>
      <div className={classNames('playbook-categories-droppable', { 'read-only': readOnly })}>
        <DragAndDrop onDragEnd={handleReorder}>
          <Drop droppableId="droppable" type="droppable-sidebar-category">
            {displayOrder.map((categoryId, categoryIndex) => {
              const category = categories.entries[categoryId]

              return (
                <Drag
                  key={categoryId}
                  draggableId={`sidebar-${categoryId}`}
                  index={categoryIndex}
                  alwaysShowIcon
                  readOnly={readOnly}
                  showDragStyle
                >
                  <CategorySidebarRow name={category.name} itemCount={category.order.length} />
                </Drag>
              )
            })}
          </Drop>
        </DragAndDrop>
      </div>

      {!readOnly && (
        <PlaybookInlineEntry
          createEntry={createAction}
          label="Add Category"
          type="category"
          useIcons
        />
      )}
    </div>
  )
}
